import ExpCandidateDrives from 'modules/Exp-Candidates/ExpCandidateDrives/index'
import driveSelector from 'modules/Exp-Candidates/selectors'
import { connect } from 'react-redux'

import { setDashboardNavs } from 'modules/Auth/actions'
import authSelector from 'modules/Auth/selectors'

import {
  getNewIndividualDriveStatus,
  getPanelList,
} from 'modules/Drives/actions'
import {
  getExpDriveListData,
  getIndidualDriveData,
  getTopicsList,
  postPassingScore,
  postShortlistCandidates,
  recreateCall,
} from 'modules/Exp-Candidates/actions'
const mapStateToProps = state => ({
  driveMetricsData: driveSelector.getDriveMetrics(state),

  dashboardNavs: authSelector.getDashboardNavs(state),
})
const mapDispatchToProps = {
  getExpDriveListData,
  getIndidualDriveData,
  setDashboardNavs,
  recreateCall,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
  getNewIndividualDriveStatus,
  getPanelList,
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpCandidateDrives)
